"use client"

import { Box, Typography, Card, CardContent, Button, Alert } from "@mui/material"
import { CheckCircle } from "@mui/icons-material"

export default function ConfirmationStep({ data, onReset }) {
  return (
    <Box sx={{ textAlign: "center" }}>
      <CheckCircle
        sx={{
          fontSize: 80,
          color: "success.main",
          mb: 2,
        }}
      />

      <Typography variant="h5" gutterBottom>
        Distribution Information Recorded Successfully!
      </Typography>

      <Alert severity="success" sx={{ mt: 3, mb: 3 }}>
        Your distribution information has been saved to the system.
      </Alert>

      <Card sx={{ mt: 3, mb: 4 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Recorded Information:
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Supplier: <strong>{data.supplier}</strong>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Project: <strong>{data.project}</strong>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Date: <strong>{new Date(data.date).toLocaleDateString()}</strong>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Stage: <strong>{data.distributionStage}</strong>
          </Typography>
        </CardContent>
      </Card>

      <Button variant="contained" onClick={onReset} size="large">
        Record New Distribution
      </Button>
    </Box>
  )
}
